**Annualized Return** measures the geometric average return of an index normalized to a one year period.
